const id = {
  marketingLiteMenu: "Marketing Lite",
  marketingLiteTitle: "Marketing Lite",
  marketingLiteSubTitle:
    "Integrasikan fitur ini untuk mulai pengiriman pesan marketing melalui WhatsApp dengan pelacakan konversi.",
  marketingLiteSettingCardTitle: "Aktifkan Marketing Lite",
  marketingLiteAPI: "Marketing Lite API",
  marketingLiteApplyAll: "Terapkan ke Semua Template Marketing",
  marketingLiteActive: "Aktif",
  marketingLiteEnable: "Aktifkan",
  marketingLiteDisable: "Nonaktifkan",
  marketingLiteWaitingApproval: "Menunggu Persetujuan",
  marketingLiteLearnMore: "Pelajari Lebih Lanjut",
  marketingLiteEnablePopUpTitle: "Terapkan ke Semua Template Marketing?",
  marketingLiteEnablePopUpSubTitle:
    "Kamu akan mengubah semua pengiriman broadcast template marketing dengan Marketing Lite API",
  marketingLiteDisablePopUpTitle: "Matikan Pengiriman Marketing Lite API?",
  marketingLiteDisablePopUpSubTitle:
    "Kamu akan mengubah semua pengiriman broadcast template marketing dengan Cloud API dan berdasarkan configurasi template",
  marketingLitePopUpConfirm: "Ya",
  marketingLitePopUpCancel: "Batalkan",
  marketingLiteRefresh: "Refresh",
  broadcastDetailMarketingLiteAPI: "Marketing Lite API",
  broadcastDetailMarketingLiteAPISubtitle:
    "Pilih pengiriman dengan Marketing Lite API",
  marketingLiteVerificationFailed: "Verifikasi Gagal",
  marketingLiteAlreadyOnboarded: "Marketing Lite Sudah Aktif",
  marketingLiteIntegrationFailed: "Aktifasi Gagal",
  marketingLiteIntegrationRequested:
    "Aktifasi Telah Diminta, Silakan info client untuk persetujuan",
  marketingLiteEnableSuccess: "Aktifasi ke semua template marketing berhasil",
  marketingLiteEnableFailed: "Aktifasi ke semua template marketing gagal",
  marketingLiteDisableFailed: "Deaktifasi ke semua template marketing gagal",
  marketingLiteDisableSuccess:
    "Deaktifasi ke semua template marketing berhasil",
};

const en = {
  marketingLiteMenu: "Marketing Lite",
  marketingLiteTitle: "Marketing Lite",
  marketingLiteSubTitle:
    "Integrate this feature to start sending marketing messages via WhatsApp with conversion tracking.",
  marketingLiteSettingCardTitle: "Enable Marketing Lite",
  marketingLiteAPI: "Marketing Lite API",
  marketingLiteApplyAll: "Apply to All Marketing Templates",
  marketingLiteActive: "Active",
  marketingLiteEnable: "Enable",
  marketingLiteDisable: "Disable",
  marketingLiteWaitingApproval: "Waiting Approval",
  marketingLiteLearnMore: "Learn More",
  marketingLiteEnablePopUpTitle: "Apply to All Marketing Templates?",
  marketingLiteEnablePopUpSubTitle:
    "You will change all marketing broadcast template sending with Marketing Lite API",
  marketingLiteDisablePopUpTitle: "Disable Marketing Lite API?",
  marketingLiteDisablePopUpSubTitle:
    "You will change all marketing broadcast template sending with Cloud API and based on template configuration",
  marketingLitePopUpConfirm: "Yes",
  marketingLitePopUpCancel: "Cancel",
  marketingLiteRefresh: "Refresh",
  broadcastDetailMarketingLiteAPI: "Marketing Lite API",
  broadcastDetailMarketingLiteAPISubtitle:
    "Choose sending with Marketing Lite API",
  marketingLiteVerificationFailed: "Verification Failed",
  marketingLiteAlreadyOnboarded: "Marketing Lite Already Onboarded",
  marketingLiteIntegrationFailed: "Integration Failed",
  marketingLiteIntegrationRequested:
    "Integration Requested, Please info client to accept",
  marketingLiteEnableSuccess: "Enable to all marketing templates successfully",
  marketingLiteEnableFailed: "Enable to all marketing templates failed",
  marketingLiteDisableFailed: "Disable to all marketing templates failed",
  marketingLiteDisableSuccess:
    "Disable to all marketing templates successfully",
};

export default { id, en };
